import { inject } from "vue";

export function isObject(obj) {
  if (Array.isArray(obj)) {
    return false;
  }

  return true;
}

export function getLength(obj) {
  if (isObject(obj)) {
    return Object.keys(obj).length;
  }

  return obj.length;
}

export function isLast(items, index) {
  return getLength(items) - 1 == index;
}

// Convert spaces to dashes and make lower case
// For use in tabs, accordions, etc
export function createSlug(text) {
  text = text.replace(/\s/g, "-");
  text = text.toLowerCase();

  return text;
}

// Use to generate random number upto and including the max parameter
export function generateRandomInteger(max) {
  return Math.floor(Math.random() * max) + 1;
}

// Convert string to camel case
export function toCamelCase(str) {
  // Using replace method with regEx
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
}

export const toPascalCase = (str) =>
  (str.match(/[a-zA-Z0-9]+/g) || [])
    .map((w) => `${w.charAt(0).toUpperCase()}${w.slice(1)}`)
    .join("");

export function convertToHash(str) {
  if (str == "") {
    return 0;
  }

  let hashString = 0;

  for (let character of str) {
    let charCode = character.charCodeAt(0);
    hashString = hashString << (5 - hashString);
    hashString += charCode;
    hashString |= hashString;
  }

  return hashString;
}

export function stripHTMLTags(str) {
  return str.replace(/(<([^>]+)>)/gi, "");
}

export function getFileType(str) {
  const mimeTypes = {
    "image/gif": "gif",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/svg": "svg",
    "image/svg+xml": "svg",
    "image/webp": "webp",
  };

  return mimeTypes[str];
}

export function capitalizeFirstLetter(str) {
  const firstLetter = str.charAt(0);

  const firstLetterCap = firstLetter.toUpperCase();

  const remainingLetters = str.slice(1);

  return firstLetterCap + remainingLetters;
}

export function buildUrl(slug = "", uri = "") {
  let url = inject("hostname") + "/";
  const addSlashes = (str) => {
    if (!str) {
      return "";
    }
    str = str.indexOf("/") === 0 ? str.slice(1) : str;
    str = str.slice(-1) !== "/" ? str + "/" : str;

    return str;
  };

  // Check if slash is present
  return url + addSlashes(uri) + addSlashes(slug);
}
